/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_OpeningInputs */



/**
* | output |
* | --- |
* | "Opening..." |
*
* @param {Explorer_Search_OpeningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_opening = /** @type {((inputs?: Explorer_Search_OpeningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_OpeningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Opening...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opening...")
	return /** @type {LocalizedString} */ ("Opening...")
});